import Vue from 'vue'
import Vuex from 'vuex'
import catalog from '@/store/modules/catalog'
import products from '@/store/modules/products'
import auth from '@/store/modules/auth'
import clients from '@/store/modules/clients'
import errors from '@/store/modules/errors'
import lang from '@/store/modules/lang'
import orders from '@/store/modules/orders'
import system from '@/store/modules/system'
import content from '@/store/modules/content'
import analogues from '@/store/modules/analogues'
import statistics from '@/store/modules/statistics'
import notifications from '@/store/modules/notifications'
import properties from '@/store/modules/properties'
import propertyTypes from '@/store/modules/property_types'
import propertyValues from '@/store/modules/property_values'
import dropCatalog from '@/store/modules/dropCatalog'
import cylinderCatalog from '@/store/modules/cylinderCatalog'
import inetOrders from '@/store/modules/inet_orders'
import novaPoshta from '@/store/modules/nova_poshta'
import search from '@/store/modules/search'
import novaPoshtaSenders from '@/store/modules/novaPoshtaSenders'
import systemEvents from '@/store/modules/systemEvents'
import rozetkaStores from '@/store/modules/rozetkaStores'
import dropOrders from '@/store/modules/dropOrders'
import dropClients from '@/store/modules/dropClients'
import dropWithdraws from '@/store/modules/dropWithdraws'
import config from '@/store/modules/config'
import paymentContragentStore from '@/store/modules/paymentContragentStore'
import cylinderPaymentContragentStore from '@/store/modules/cylinderPaymentContragentStore'
import dropMessageStore from '@/store/modules/dropMessageStore'
import rolesStore from '@/store/modules/rolesStore'
import workersStore from '@/store/modules/workersStore'
import wsStore from '@/store/modules/wsStore'
import notificationStore from '@/store/modules/notificationStore'
import cylinderSettingStore from '@/store/modules/cylinderSettingStore'
import cylinderArticleStore from '@/store/modules/cylinderArticleStore'
import cylinderBlogStore from '@/store/modules/cylinderBlogStore'
import dropSettingStore from '@/store/modules/dropSettingStore'
import paymentDocumentStore from '@/store/modules/paymentDocumentStore'
import cylinderSpecialsStore from '@/store/modules/cylinderSpecialsStore'
import etalonSpecialsStore from '@/store/modules/etalonSpecialsStore'
import dropSpecialsStore from '@/store/modules/dropSpecialsStore'
import specialTemplateStore from '@/store/modules/specialTemplateStore'
import providerStore from '@/store/modules/providerStore'
import commercialProposalsStore from '@/store/modules/commercialProposalsStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    catalog,
    products,
    clients,
    errors,
    lang,
    system,
    orders,
    content,
    analogues,
    statistics,
    notifications,
    properties,
    propertyTypes,
    propertyValues,
    dropCatalog,
    cylinderCatalog,
    inetOrders,
    novaPoshta,
    search,
    novaPoshtaSenders,
    systemEvents,
    rozetkaStores,
    dropOrders,
    dropClients,
    dropWithdraws,
    config,
    paymentContragentStore,
    cylinderPaymentContragentStore,
    dropMessageStore,
    rolesStore,
    workersStore,
    wsStore,
    notificationStore,
    cylinderSettingStore,
    cylinderArticleStore,
    cylinderBlogStore,
    dropSettingStore,
    paymentDocumentStore,
    cylinderSpecialsStore,
    etalonSpecialsStore,
    dropSpecialsStore,
    specialTemplateStore,
    providerStore,
    commercialProposalsStore
  }
})
